<!-- Bulk Upload -->
<div class="page-header">
  <div class="header-content">
    <div class="header-main">
      <div class="header-icon">
        <i class="fas fa-upload"></i>
      </div>
      <div class="header-text">
        <h1 class="page-title">Bulk Update</h1>
        <p class="page-description">Update inventory stock quantities in bulk</p>
      </div>
    </div>
    <div class="header-actions">
      <button
        class="btn btn-primary"
        (click)="bulkUpload()"
        [disabled]="isLoading || filteredInventories.length === 0">
        <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        <i class="fas fa-save me-1" *ngIf="!isLoading"></i>
        {{ isLoading ? 'Uploading...' : 'Save Changes' }}
      </button>
    </div>
  </div>
</div>

<!-- Search Filter -->
<div class="filters-panel">
  <div class="search-section">
    <div class="search-box">
      <div class="search-input-wrapper">
        <i class="fas fa-search search-icon"></i>
        <input
          type="text"
          class="search-input"
          [(ngModel)]="searchTerm"
          placeholder="Search inventory by name..."
          (input)="filterInventories()"
        />
      </div>
    </div>
  </div>
  <div class="stats-section">
    <div class="stat-card">
      <div class="stat-icon total">
        <i class="fas fa-boxes"></i>
      </div>
      <div>
        <div class="stat-number">{{ filteredInventories.length }}</div>
        <div class="stat-label">Items Shown</div>
      </div>
    </div>
  </div>
</div>

<!-- Inventory Table -->
<div class="data-panel">
  <div class="panel-header">
    <div class="panel-title">
      <div class="title-icon">
        <i class="fas fa-table"></i>
      </div>
      <div class="title-content">
        <div class="title-text">Inventory Items</div>
        <div class="title-subtitle">Enter new quantities for items you want to update</div>
      </div>
    </div>
  </div>

  <div class="panel-body">
    <div class="table-container">
      <table class="table align-middle">
        <thead>
          <tr>
            <th>Item Name</th>
            <th style="width: 200px;">Quantity</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let inventory of filteredInventories">
            <td>
              <span style="font-size: 13px; font-weight: 500; color: var(--text-primary);">{{ inventory.name }}</span>
            </td>
            <td>
              <input
                type="number"
                class="form-control"
                [(ngModel)]="inventory.quantity"
                [attr.min]="1"
                placeholder="Enter quantity"
                style="max-width: 160px;"
              />
            </td>
          </tr>
          <tr *ngIf="filteredInventories.length === 0">
            <td colspan="2">
              <div class="empty-state">
                <div class="empty-icon">
                  <i class="fas fa-search fa-3x"></i>
                </div>
                <div class="empty-content">
                  <h5>No Items Found</h5>
                  <p>No inventory items match your search criteria. Try a different search term.</p>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
